import axios from 'axios';
import moment from 'moment';

export const serverUrl = `${process.env.REACT_APP_SERVER_URL || ''}`;

axios.defaults.baseURL = serverUrl;
axios.defaults.headers.post['Content-Type'] ='application/json';

function setCompanyCodeHeader() {
    let companyCode = localStorage.getItem("companyCode");
    console.log(companyCode);
    if(companyCode) {
        axios.defaults.headers.common['companyCode'] = companyCode;
    }
}

const ServerGateway = {
    validateLogin: async function(emailId, password) {
        try {
            const payload = { emailId: emailId, password: password };
            let response = await axios.post('/user/validate', payload);
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::validateLogin ->"+ error);
            throw error;
        }
        return false;
    },
    getEmployees: async function(name, groupId, pageNumber = 1, pageSize = 100) {
        try {
            setCompanyCodeHeader();
            const params = { name, groupId, pageNumber, pageSize, activeOnly: true, fields: 'Id,Name,EmployeeNumber,GroupName,DesignationName'  };
            let response = await axios.get('/master/employee', { params });
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getEmployees ->"+ error);
            throw error;
        }
        return undefined;
    },    
    getEmployee: async function(id) {
        try {
            setCompanyCodeHeader();
            let response = await axios.get('/master/employee/'+ id);
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getEmployees ->"+ error);
            throw error;
        }
        return undefined;
    },
    getPayslips: async function(year, month) {
        try {
            setCompanyCodeHeader();
            const params = { financialYear: (month < 4) ? (year - 1) : year, month, payslipType: 'Salary', groupId: 0, processedOnly: true };
            let response = await axios.get('/employee/payslip', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getPayslip ->"+ error);
            throw error;
        }
        return undefined;
    },
    getAttendance: async function(date, groupId) {
        try {
            setCompanyCodeHeader();
            let endDate = moment(date).add(1, 'days').format("YYYY-MM-DD");
            const params = { durationId: "-1", from: date, to: endDate, groupId  };
            let response = await axios.get('attendance/shiftwise/daily', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getEmployeeAttendance: async function(fromDate, toDate, employeeId) {
        try {
            setCompanyCodeHeader();
            const params = { durationId: "-1", from: fromDate, to: toDate, employeeId  };
            let response = await axios.get('attendance/shiftwise/employee', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getLeaveTypes: async function() {
        try {
            setCompanyCodeHeader();
            let response = await axios.get('/attendance/leaveType');
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getLeaveTypes ->"+ error);
            throw error;
        }
        return undefined;
    },
    getEmployeeGroups: async function() {
        try {
            setCompanyCodeHeader();
            let response = await axios.get('/master/employee/group');
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getLeaveTypes ->"+ error);
            throw error;
        }
        return undefined;
    },
    getLeaveBalance: async function(employeeId) {
        try {
            setCompanyCodeHeader();
            const params = { employeeId  };
            let response = await axios.get('/attendance/leave/balance', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getLeaveTypes ->"+ error);
            throw error;
        }
        return undefined;
    },
    getLeaves: async function(employeeId, durationId, from, to) {
        try {
            setCompanyCodeHeader();
            const params = { employeeId, durationId, from, to  };
            let response = await axios.get('/attendance/leave', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getLeaveTypes ->"+ error);
            throw error;
        }
        return undefined;
    },
    saveLeaveRequest: async function(leaveRequest) {
        try {
            setCompanyCodeHeader();
            let response = await axios.post('/attendance/leave', leaveRequest);
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::saveLeaveRequest ->"+ error);
            throw error;
        }
        return undefined;
    },
    getRegularizations: async function(employeeId, durationId, from, to, groupId, reportsTo) {
        try {
            setCompanyCodeHeader();
            const params = { employeeId, durationId, from, to, groupId, reportsTo  };
            let response = await axios.get('/attendance/regularization', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getRegularization ->"+ error);
            throw error;
        }
        return undefined;
    },
    approveRegularization: async function(regularizationId, status, comment) {
        try {
            setCompanyCodeHeader();
            let body = {
                id: regularizationId,
                approvalStatus: status,
                approverRemarks: comment
            };
            let response = await axios.post('/attendance/regularization/approve', body);
            if (response) {
                return response.data;
            }
        }  catch (error) {
            console.error("Error in ArthaGateway::approveRegularization ->"+ error);
            throw error;
        }
        return undefined;
    },
    getLocations: async function() {
        try {
            setCompanyCodeHeader();
            let response = await axios.get('/company/location');
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getLocations ->"+ error);
            throw error;
        }
        return undefined;
    },
    getGatepass: async function(employeeId, durationId) {
        try {
            setCompanyCodeHeader();
            const params = { employeeId, durationId  };
            let response = await axios.get('/attendance/gatepass', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getGatepass ->"+ error);
            throw error;
        }
        return undefined;
    },
    getCompanySettings: async function() {
        try {
            setCompanyCodeHeader();
            let response = await axios.get('/master/settings');
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getGatepass ->"+ error);
            throw error;
        }
        return undefined;
    },
    getUpcomingBirthdays: async function(fromDate, toDate) {
        try {
            setCompanyCodeHeader();
            const params = { durationId: "-1", from: fromDate, to: toDate, fields: 'Id,Name,EmployeeNumber,GroupName,DesignationName,DOB,JoiningDate' };
            let response = await axios.get('/master/employee/birthday', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getEmployeesByBirthday ->"+ error);
            throw error;
        }
        return undefined;
    },
    getUpcomingWorkAnniversaries: async function(fromDate, toDate) {
        try {
            setCompanyCodeHeader();
            const params = { durationId: "-1", from: fromDate, to: toDate, fields: 'Id,Name,EmployeeNumber,GroupName,DesignationName,DOB,JoiningDate' };
            let response = await axios.get('/master/employee/workAnniversary', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getEmployeesByAnniversary ->"+ error);
            throw error;
        }
        return undefined;
    },
     getTodos: async function(year, month) {
        try {
            setCompanyCodeHeader();
            const params = { year, month  };
            let response = await axios.get('/master/todo', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getLeaveTypes ->"+ error);
            throw error;
        }
        return undefined;
    }
}

export default ServerGateway;